<template>
  <v-container
  fluid
  class="background"
  fill-height
  >
    <v-col cols="12">
      <v-row
        align="center"
        justify="center"
        class="mx-6"
      >
          <v-img
          contain
            src="../assets/entreGOALS-color.png"
            max-width="300"
            class="mx-10 d-flex d-sm-none"
          ></v-img>
          <v-img
          contain
            src="../assets/entreGOALS-color.png"
            max-width="500"
            class="mx-10 d-none d-sm-flex"
          ></v-img>
      </v-row>
      <v-row
        align="center"
        justify="center"
        class="my-3"
      >
        <div class="text-center font-weight-black display-4
        deep-orange--text text--lighten-2 ma-5 d-none d-sm-flex">
          An Online Summit for <br>Entrepreneurs in Nevada</div>
        <div class="text-center font-weight-black display-2
        deep-orange--text text--lighten-2 ma-5 d-flex d-sm-none">
          An Online Summit for <br>Entrepreneurs in Nevada</div>
      </v-row>
       <div
        class="text-center display-2 white--text text-xs-center my-5">
        November 14-15, 2019
      </div>
      <v-row justify="center">
        <McSignup />
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import McSignup from './McSignup.vue';

export default {

  name: 'Landing',
  components: {
    McSignup,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
.background{
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../assets/redrockroad1.jpg");
  background-size: cover;
  background-position: center;
}
.background:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(60deg, #2893c5, #000000);
  opacity: .7;
  z-index: 1;
}
.background > * {
    z-index: 3;
}
/** { background-color: rgba(255,0,0,.2); }
  * * { background-color: rgba(0,255,0,.2); }
  * * * * { background-color: rgba(255,0,255,.2); }
  * * * * * { background-color: rgba(0,255,255,.2); }
  * * * * * * { background-color: rgba(255,255,0,.2); }
  * * * * * * * { background-color: rgba(255,0,0,.2); }
  * * * * * * * * { background-color: rgba(0,255,0,.2); }
  * * * * * * * * * { background-color: rgba(0,0,255,.2); }*/
</style>
